import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { FinalitiesService } from 'src/app/shared/services/finalities.service';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { NotifierService } from 'angular-notifier';
import { GenerateInvoiceThirdPartyComponent } from '../generate-invoice-third-party/generate-invoice-third-party.component';
import { GenerateInvoiceForMeComponent } from '../generate-invoice-for-me/generate-invoice-for-me.component';

declare const $: any;

@Component({
  selector: 'app-new-order-modal',
  templateUrl: './new-order-modal-outbound.component.html',
  styleUrls: ['./new-order-modal-outbound.component.scss'],
})
export class NewOrderModalOutboundComponent implements OnInit {
  finalityForm: FormGroup;
  finalities: FinalitiesDto[];
  filteredFinalities: FinalitiesDto[];
  showFinalityIdSelect: boolean = false;
  private readonly notifier: NotifierService;

  controlFinalityType: string = '.js-control-finality-type';
  controlFinalityId: string = '.js-control-finality-id';

  get finalityFormControl() {
    return this.finalityForm.controls;
  }

  get finality(): any {
    const finality = this.finalityForm.value;
    return finality;
  }

  constructor(
    private fb: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private modalService: BoobleModalService,
    private readonly finalitiesService: FinalitiesService
  ) {
    this.finalityForm = fb.group({
      thirdPartyOrder: [null, Validators.required],
      finalityType: ['', Validators.required],
      finalityId: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.setControls();

    this.finalitiesService.get().subscribe((getResult) => {
      this.finalities = getResult.data;
    });
  }

  setControls() {
    $(this.controlFinalityType).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });
    $(this.controlFinalityId).select2({
      language: {
        noResults: function () {
             return "Sem resultados";
        }
    }
    });

    let t = this;
    $(this.controlFinalityType).on('change', function () {
      t.changeFinalityType($(this).val());
    });
    $(this.controlFinalityId).on('change', function () {
      t.changeFinalityId($(this).val());
    });
  }

  changeFinalityType(text: String) {
    this.finalityForm.controls['finalityType'].patchValue(text);
  }

  changeFinalityId(text: String) {
    this.finalityForm.controls['finalityId'].patchValue(
      text.substring(text.indexOf(' ') + 1)
    );
  }

  selectOrderForMe() {
    this.finalityForm.controls['thirdPartyOrder'].patchValue(false);
  }

  selectThirdPartyOrder() {
    this.finalityForm.controls['thirdPartyOrder'].patchValue(true);
  }

  filterFinality(event: any) {
    if (event) {
      const newFilter = this.finalities.filter((item) => item.type === event);
      this.filteredFinalities = newFilter;
      this.finalityForm.controls['finalityId'].patchValue(this.filteredFinalities[0].id);
    }
    this.showFinalityIdSelect = true;
  }

  goToInvoiceModal() {
    this.finality.thirdPartyOrder
      ? this.openThirdPartyOrderModal()
      : this.openOrderForMeModal();
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  openOrderForMeModal() {
    this.modalService.present(GenerateInvoiceForMeComponent, this.finality);
  }

  openThirdPartyOrderModal() {
    this.modalService.present(
      GenerateInvoiceThirdPartyComponent,
      this.finality
    );
  }
}
